const input = document.querySelector('.js-other');
const select = document.getElementById('cottage');

if (select) {
	select.addEventListener('change', function() {
		var value = select.options[select.selectedIndex].value;

		if (value == 'other') {
			input.classList.add('is-active');
		} else {
			input.classList.remove('is-active');
		}
	});

	select.form.addEventListener('submit', function() {
		var value = select.options[select.selectedIndex].value;

		if (value !== 'other') {
			input.remove();
		}
	});
}
